import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { withIntl, IntlProps } from 'ha/i18n';

import * as SearchFilters from 'ha/types/SearchFilters';
import { CanonicalRegistration } from 'ha/constants/Filters';

import FilterSwitchGroup from './FilterSwitchGroup';

interface Props {
  registration: SearchFilters.RegistrationFilterValue;
  className?: string;
  onChange: (value: SearchFilters.RegistrationFilterValue) => void;
}

interface RegistrationOption {
  value: SearchFilters.RegistrationValue;
  label: string;
  'data-test-locator'?: string;
}

export const RegistrationFilter: React.SFC<Props & IntlProps> = ({
  registration,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Registration')}</Typography>

    <FilterSwitchGroup
      value={registration as string}
      onChange={(val: SearchFilters.RegistrationFilterValue) => onChange(val)}
      options={
        [
          {
            value: CanonicalRegistration.Possible,
            label: T('Registration Possible'),
            'data-test-locator': 'Filter Registration Possible',
          },
          {
            value: CanonicalRegistration.NotPossible,
            label: T('Registration Not Possible'),
            'data-test-locator': 'Filter Registration Not Possible',
          },
        ] as RegistrationOption[]
      }
    />
  </React.Fragment>
);

export default withIntl(RegistrationFilter);
